import React from "react";
import TeamSection from "../../../Shared/TeamSection/TeamSection";
import styles from "./ConsultantMatching.module.css";
import { teamData } from "../../../../data/teamData.js";

//자비출판 -컨설턴트 탭
const consultantsData = [
  {    
    name: "옥 대표",
    specialty: "에이콘 비즈니스 총괄",
    tags: ["출판 사업 전략", "브랜드 콘텐츠 아키텍처", "글로벌 콘텐츠 기획"],
    achievements: [
      "에이콘출판 29년 전문성 기반 저자 맞춤형 출판 플랫폼 에이콘온 창립 및 총괄",
      "기획·편집·디자인·마케팅·유통을 아우르는 출판 밸류체인 전략 설계",
      "국내외 콘텐츠 브랜드 가치 극대화 및 글로벌 출판 시장 진출 전략 기획",      
    ],
  },
  {    
    name: "황 사장",
    specialty: "에이콘 브랜드 출판 편집·기획 총괄 디렉터",
    tags: ["편집 기획 총괄", "콘텐츠 품질 관리", "출판 프로세스 설계"],
    achievements: [
      "29년 출판 현장 경험 기반 편집·기획·제작 전 공정 총괄",
      "콘텐츠 브랜드 가치를 높이는 출판 솔루션 설계",
      "출판 콘텐츠 마케팅과 브랜드 전략을 아우르는 실무 중심 총괄 디렉터",      
    ],
  },
  {    
    name: "박 프로",
    specialty: "아마존 출판 대행 및 국내외 SNS 마케터",
    tags: ["아마존 킨들(KDP) 전략 기획", "국내외 SNS 홍보"],
    achievements: [
      "아마존 KDP 기반 도서 출간 프로세스 총괄",
      "글로벌 트렌드 분석을 통한 장르별 SEO 최적화 전략 수립",
      "국내외 독자 니즈를 반영한 마케팅 카피라이팅",      
    ],
  },  
  {  
    name: "강 프로",
    specialty: "도서 기획 및 하이브리드 편집 전문가",
    tags: ["하이브리드 콘텐츠", "IT 전문서 기획"],
    achievements: [
      "IT 전문서 다수 기획 및 출간",
      "교보문고 ‘올해의 책’ 다수 기획 참여",
      "온라인 강의 콘텐츠 및 연계 출판물 기획",
      "교육 콘텐츠와 도서의 융합형 기획 운영",
    ],
  },
  {  
    name: "임 프로",
    specialty: "IT 전문서 출판 운영 디렉터",
    tags: ["편집 프로세스", "출판 운영", "출간 일정"],
    achievements: [
      "80권 이상 IT 전문서 기획·편집",
      "교정·조판·인쇄 포함 전 과정 실무 총괄",
      "일정 준수율 높은 체계적인 제작 프로세스 운영",
      "출판 운영 전반을 아우르는 실전형 출판 매니저",
    ],
  },  
  {    
    name: "광 프로",
    specialty: "콘텐츠 마케팅 및 독자 커뮤니케이션 전문가",
    tags: ["도서 기획·편집", "온오프라인 통합 콘텐츠 브랜딩"],
    achievements: [
      "공공 및 지역 문화 프로젝트 기획 다수 수행",
      "정보 전달형 인쇄 출판물 기획 및 원고 집필",
      "행사·공연·앱 기획 등 온오프라인 통합 기획",
      "언론 홍보 및 스토리텔링 기반 콘텐츠 브랜딩",
    ],
  },
  {  
    name: "백 프로",
    specialty: "디지털 비주얼 마케팅 및 멀티플랫폼 디자인 전문가",
    tags: ["콘텐츠 시각화", "SNS·웹진 최적화", "비주얼 브랜딩"],
    achievements: [
      "디지털·종이책 통합 내지 템플릿 설계 및 편집 디자인",
      "SNS·웹진·상세페이지·카드뉴스 등 매체별 특성에 최적화된 시각 디자인",
      "리플렛, 굿즈, 홍보 브로슈어 등 다채로운 기획 제작",
      "장르별 독자 분석 기반 비주얼 브랜딩 및 콘텐츠 시각 요소 제작",
    ],
  },
  {  
    name: "최 프로",
    specialty: "경영지원 & 계약·정산 전문가",
    tags: ["계약 관리", "비용 처리", "저자 정산"],
    achievements: [
      "저자 계약서 작성 및 검토·관리 총괄",
      "인세 정산 및 비용 처리 전 과정 담당",
      "출판 계약 관련 행정 지원 및 저자·파트너사 계약 관계 관리",
      "경영지원 전반을 아우르는 안정적인 출판 운영 기반 구축"    
    ],
  },
  {  
    name: "김 프로",
    specialty: "콘텐츠 마케팅 및 독자 커뮤니케이션 전문가",
    tags: ["서점 유통", "홍보 전략", "채널 운영"],
    achievements: [
      "콘텐츠 중심 마케팅 및 온라인 서점 MD 협업",
      "독서모임, 굿즈 제작, 독립서점 운영 경험",
      "블로그·SNS·유튜브 등 다채널 홍보 전략 실행",
      "출간 후 독자 반응 모니터링 및 사후 커뮤니케이션 총괄",
    ],
  },
];

const matchingProcessSteps = [
  {
    badge: "1단계",
    title: "도서 분석",
    description: "장르, 주제, 타겟 독자 파악",
    imageUrl: "/images/ConsultantMatching-step-1.png",
  },
  {
    badge: "2단계",
    title: "전문가 매칭",
    description: "분야별 최적 컨설턴트 선정",
    imageUrl: "/images/ConsultantMatching-step-2.png",
  },
  {
    badge: "3단계",
    title: "초기 상담",
    description: "무료 상담을 통한 방향 설정",
    imageUrl: "/images/ConsultantMatching-step-3.png",
  },
  {
    badge: "4단계",
    title: "컨설팅 시작",
    description: "맞춤형 컨설팅 서비스 제공",
    imageUrl: "/images/ConsultantMatching-step-4.png",
  },
];

const ConsultantMatching = () => {
  return (
    <>
      <TeamSection
        title="에이콘에서는 전문 컨설턴트가 작가 여러분과 함께합니다!"
        data={teamData}
        layout="grid"
      />
      <section className={styles.matchingProcessSection}>
        <h2 className={styles.matchingProcessTitle}>컨설턴트 매칭 프로세스</h2>
        <div className={styles.matchingProcessFlow}>
          {matchingProcessSteps.map((step, index) => (
            <div key={index} className={styles.matchingStep}>
              <img
                src={step.imageUrl}
                alt={step.title}
                className={styles.stepImage}
              />
              <span className={styles.stepBadge}>{step.badge}</span>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDescription}>{step.description}</p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
};

export default ConsultantMatching;
